<template>
  <!--<layout-horizontal></layout-horizontal>-->

  <div class="horizontal-layout-class xatia">
    <horizontal-navbar></horizontal-navbar>
    <router-view :key="$route.fullPath"/>

    <!--<app-customizer-->
            <!--v-if="showCustomizer"-->
            <!--slot="customizer"-->
    <!--/>-->
  </div>

  <!--</layout-horizontal>-->

</template>

<script>
// import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from "@themeConfig"
import HorizontalNavbar from "../../views/navbar/HorizontalNavbar";

export default {
  components: {
    HorizontalNavbar,
    // LayoutHorizontal,
    // AppCustomizer,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
